<app-toast></app-toast>
<div class="flex flex-col min-h-screen">
  <app-header></app-header>
  <main class="flex-grow">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
<app-whatsapp-button></app-whatsapp-button>